module.exports = __webpack_public_path__ + "static/media/hand-sanitizer.e1bc93af.svg";